// src/components/CertificatesPage.jsx
import React, { useEffect, useState } from "react";
import MenuLayout from "./MenuLayout";
import "../styles/CertificatesPage.css";
import { getUserBadges, getChallengeCertificates, getWithdrawalCertificates } from "../api/achievements";

const normalizeImage = (url) => {
  if (!url) return "/images/certificate.png";
  if (url.startsWith("http")) return url;
  return `https://api.touchprop.com${url}`;
};

const tabs = [
  { key: "badges", label: "مدال ها" },
  { key: "challenge", label: "چالش ها" },
  { key: "withdraw", label: "برداشت ها" },
];

const CertificatesPage = () => {
  const [activeTab, setActiveTab] = useState("badges");
  const [receivedBadges, setReceivedBadges] = useState([]);
  const [unreceivedBadges, setUnreceivedBadges] = useState([]);
  const [challengeCerts, setChallengeCerts] = useState([]);
  const [withdrawCerts, setWithdrawCerts] = useState([]);
  const [error, setError] = useState("");

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [badges, challenges, withdrawals] = await Promise.all([
          getUserBadges(),
          getChallengeCertificates(),
          getWithdrawalCertificates(),
        ]);
        setReceivedBadges(badges?.received_badges || []);
        setUnreceivedBadges(badges?.unreceived_badges || []);
        setChallengeCerts(challenges || []);
        setWithdrawCerts(withdrawals || []);
      } catch (err) {
        setError(err.message || "خطا در دریافت اطلاعات");
      }
    };
    fetchData();
  }, []);

  const renderBadgeCard = (item) => (
    <div className="badge-card" key={item.id}>
      <img src={normalizeImage(item.image)} alt={item.name} className="badge-icon" />
      <div className="badge-info">
        <div className="badge-title">{item.name}</div>
        <div className="badge-subtitle">---</div>
        <span className="badge-line" />
      </div>
    </div>
  );

  const renderCertCard = (card) => (
    <div className="cert-card" key={card.id}>
      <div className="cert-img-wrap">
        <img src={normalizeImage(card.image_url || card.image)} alt="certificate" />
      </div>
      <div className="cert-meta">
        <div className="cert-row">
          <span>شماره سفارش:</span>
          <span>{card.order_number}</span>
        </div>
        <div className="cert-row">
          <span>نام چالش:</span>
          <span>{card.challenge_name}</span>
        </div>
        <div className="cert-row">
          <span>نوع حساب:</span>
          <span>{card.account_type}</span>
        </div>
        {card.total_profit && (
          <div className="cert-row">
            <span>سود کل:</span>
            <span>{card.total_profit}</span>
          </div>
        )}
        {card.withdrawal_amount && (
          <div className="cert-row">
            <span>مبلغ برداشت:</span>
            <span>{card.withdrawal_amount}</span>
          </div>
        )}
        <div className="cert-row">
          <span>تاریخ دریافت:</span>
          <span>{card.date_awarded}</span>
        </div>
      </div>
      <button className="cert-download">دانلود</button>
    </div>
  );

  return (
    <MenuLayout>
      <section className="cert-page">
        <header className="cert-header">
          <h1 className="cert-title">سرتیفیکت ها</h1>
          <p className="cert-subtitle">
            افتخاراتت رو ببین ؛ داشتن هر کدوم از این ها یعنی یک مرحله بالاتر رفتی
          </p>
        </header>

        <div className="cert-tabs">
          {tabs.map((t) => (
            <button
              key={t.key}
              className={`cert-tab ${activeTab === t.key ? "active" : ""}`}
              onClick={() => setActiveTab(t.key)}
            >
              {t.label}
            </button>
          ))}
        </div>

        {error && <div className="cert-placeholder">{error}</div>}

        {activeTab === "badges" && !error && (
          <>
            <section className="cert-section">
              <h3 className="cert-section-title">نشان‌های دریافت شده</h3>
              <div className="badge-grid">
                {receivedBadges.map(renderBadgeCard)}
                {receivedBadges.length === 0 && <div className="cert-placeholder">نشان دریافت نشده است.</div>}
              </div>
            </section>

            <section className="cert-section">
              <h3 className="cert-section-title">نشان‌های قابل دریافت</h3>
              <div className="badge-grid">
                {unreceivedBadges.map(renderBadgeCard)}
                {unreceivedBadges.length === 0 && <div className="cert-placeholder">نشان جدیدی ندارید.</div>}
              </div>
            </section>
          </>
        )}

        {activeTab === "challenge" && !error && (
          <section className="cert-section">
            <h3 className="cert-section-title">سرتیفیکیت چالش</h3>
            <div className="cert-grid">
              {challengeCerts.map(renderCertCard)}
              {challengeCerts.length === 0 && <div className="cert-placeholder">سرتیفیکیتی ثبت نشده است.</div>}
            </div>
          </section>
        )}

        {activeTab === "withdraw" && !error && (
          <section className="cert-section">
            <h3 className="cert-section-title">سرتیفیکیت برداشت</h3>
            <div className="cert-grid">
              {withdrawCerts.map(renderCertCard)}
              {withdrawCerts.length === 0 && <div className="cert-placeholder">سرتیفیکیتی ثبت نشده است.</div>}
            </div>
          </section>
        )}
      </section>
    </MenuLayout>
  );
};

export default CertificatesPage;
